module.exports = __webpack_public_path__ + "static/media/Iris Street, San Francisco, CA19.4cb7406c.jpg";